export default __webpack_public_path__ + "static/media/kitchen4-afterC-480w.f68466a1.webp";